import { Seo } from '../components/Seo';
import {Header} from '../components/Header';
import {Footer} from '../components/Footer';

const Privacy = () => {

  return (
    <>


      <Seo
        title="title"
        description="descr"
        type="webapp"
      />

      <Header selectedNavitem="about" />

        <p>privacy</p>

      <Footer />

    </>
    )
  };
  
  export default Privacy;